import React, { Suspense } from "react"
//import HeaderAdminMenu from "../../admin/auth/HeaderAdminMenu"
//import FieldAdmin from "../../admin/auth/field/FieldAdmin"
//import Errors from "../../admin/auth/lib/Errors"

const HeaderAdminMenu = React.lazy(() =>
    import("admin/auth").then(module => ({ default: module.HeaderAdminMenu }))
)
const FieldAdmin = React.lazy(() =>
    import("admin/auth").then(module => ({ default: module.FieldAdmin }))
)
const Errors = React.lazy(() => import("admin/auth").then(module => ({ default: module.Errors })))

const Admin = ({ user, logout, node }) => {
    if (!user) return null
    return (
        <>
            {user && user.is("editor") && (
                <div id="field-admin-container">
                    <Suspense fallback={null}>
                        <FieldAdmin user={user} />
                    </Suspense>
                </div>
            )}
            <Suspense fallback={null}>
                <HeaderAdminMenu user={user} logout={logout} node={node} />
            </Suspense>
            <Suspense fallback={null}>
                <Errors />
            </Suspense>
        </>
    )
}
export default Admin
